import Vue from 'vue'
import VoerroTagsInput from '@voerro/vue-tagsinput'
import '@voerro/vue-tagsinput/dist/style.css'

Vue.component('tags-input', VoerroTagsInput)